import apiRoutes from '../../../apiRoutes';
import { invalidateOn } from '../../utils';
import { rootApi } from '../index';

rootApi.injectEndpoints({
  endpoints: (build) => ({
    getWorkExperienceCategories: build.query({
      query: (params) => ({
        url: apiRoutes.workExperienceCategories(),
        params,
      }),
      providesTags: ['WORK_EXPERIENCE_CATEGORIES'],
    }),
    getWorkExperienceCategory: build.query({
      query: (langId) => ({
        url: apiRoutes.workExperienceCategories(langId),
      }),
      providesTags: ['WORK_EXPERIENCE_CATEGORY'],
    }),
    editWorkExperienceCategory: build.mutation({
      query: ({ id, body }) => ({
        url: apiRoutes.workExperienceCategories(id),
        method: 'PUT',
        body,
      }),
      invalidatesTags: invalidateOn({ success: ['WORK_EXPERIENCE_CATEGORIES', 'WORK_EXPERIENCE_CATEGORY'] }),
    }),
    createWorkExperienceCategory: build.mutation({
      query: ({ body }) => ({
        url: apiRoutes.workExperienceCategories(),
        method: 'POST',
        body,
      }),
      invalidatesTags: invalidateOn({ success: ['WORK_EXPERIENCE_CATEGORIES', 'WORK_EXPERIENCE_CATEGORY'] }),
    }),
  })
});

export const {
  useGetWorkExperienceCategoriesQuery,
  useGetWorkExperienceCategoryQuery,
  useEditWorkExperienceCategoryMutation,
  useCreateWorkExperienceCategoryMutation,
} = rootApi;
